export const HOLD_RETURNS_FIELD = "holdReturns";

export const RETURN_SETTINGS_FIELDS = [HOLD_RETURNS_FIELD];
